import React from 'react';

const NoBidsEmptyState = () => {
  return (
    <div className="text-center text-gray-600 py-10" data-testid="no-bids">
      No bids yet. Share the job with installers to receive bids.
    </div>
  );
};

export default NoBidsEmptyState;
